module.exports = __webpack_public_path__ + "img/primary2.ab078330.png";